import { render, staticRenderFns } from "./OrderSheet4LabelSheetFrame.vue?vue&type=template&id=c60d1f64&scoped=true"
import script from "./OrderSheet4LabelSheetFrame.vue?vue&type=script&lang=js"
export * from "./OrderSheet4LabelSheetFrame.vue?vue&type=script&lang=js"
import style0 from "./OrderSheet4LabelSheetFrame.vue?vue&type=style&index=0&id=c60d1f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60d1f64",
  null
  
)

export default component.exports